(function() {
	angular.module('meanApp').controller('aboutCtrl', aboutCtrl);

	aboutCtrl.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'context',
		'$state'
	];
	function aboutCtrl($scope, $rootScope, $location, context, $state) {
		var vm = this;

		context.set({
			contextName: 'A propos',
			title : 'Contact, Foire aux questions, Création de widget',
			goBack: true
		});

		vm.goToContact = function() {
			$state.go('contact');
		};

		vm.goToFAQ = function() {
			$state.go('faq');
		};

		vm.goToWidget = function() {
			$state.go('recipeWidgetNone');
		};
    }
})();
